import { render, staticRenderFns } from "./NetGsmChannels.vue?vue&type=template&id=c2db592a&scoped=true"
import script from "./NetGsmChannels.vue?vue&type=script&lang=js"
export * from "./NetGsmChannels.vue?vue&type=script&lang=js"
import style0 from "./NetGsmChannels.vue?vue&type=style&index=0&id=c2db592a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2db592a",
  null
  
)

export default component.exports